import { getRandomNumber } from '@/helpers/random';

export const getMessageData = ({ engagement }) => {
  const { perChannel, total, totalUnique, uniquesPerChannel } = engagement;
  const channelData = Object.entries(perChannel);
  const formatKey = key => {
    const formatedKey = key.replace(/([A-Z])/g, ' $1').trim();
    return formatedKey.charAt(0).toUpperCase() + formatedKey.slice(1);
  };
  const chartData = channelData
    .filter(([key, val]) => key[0] !== '_' && val)
    .map(([key, val]) => [formatKey(key), { total: val, unique: uniquesPerChannel[key] }]);
  return {
    chartData,
    total,
    uniques: totalUnique,
    promos: `${getRandomNumber(0, 100)}% ??`,
    proportion: `${getRandomNumber(0, 25)}% ??`,
  };
};

export const getCommercialLoadData = ({ commercialLoad }) => commercialLoad;
export const getMusicalLoadData = ({ musicalLoad }) => musicalLoad;
export const getTopTracksData = ({ topTracks }) => topTracks;
export const getContentThreadsData = ({ contentThreads }) => contentThreads.topics;
export const getAudienceData = ({ audience }) => JSON.parse(audience.stats);
export const getPromotionsData = ({ promotions }) => {
  const uniqueMap = promotions.uniques.reduce((a, x) => {
    a[x.campaignId] = x.value; // eslint-disable-line
    return a;
  }, {});

  return promotions.entries
    .map(x => ({
      ...x,
      uniques: uniqueMap[x.campaignId],
      entries: x.value,
    }))
    .sort((a, b) => b.entries - a.entries);
};



// WEBPACK FOOTER //
// ./src/containers/analytics/programmingDashboardUtils.js